(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('historicoMapas', HistoricoMapas);

  function HistoricoMapas() {
    return {
      restrict: 'E',
      controller: 'HistoricoMapasCtrl',
      controllerAs: 'mapas',
      templateUrl: 'views/propriedade/historico-mapas.html'
    };
  }
}());
